"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateListPresentingSessionsResult = void 0;
const validation_1 = require("@fmtk/validation");
const PresentingSession_1 = require("./PresentingSession");
exports.validateListPresentingSessionsResult = (0, validation_1.array)(PresentingSession_1.validatePresentingSession);
//# sourceMappingURL=ListPresentingSessionsResult.js.map